import React, { PureComponent } from "react";
import Slider from "react-slick";
import clsx from "clsx";

import { selectFormat, getMetricForColumn } from "./../Utils/Utils.js";
import { XrayCarouselNav, trackXrayCarousel } from "./../Utils/XrayUtils";

class XrayAnalysisSlider extends PureComponent {
  state = {
    currentSlide: 1,
  };

  render() {
    const extra = this.props.extra;

    const data = extra.filter(
      (d) => d.value !== null && (d.value.total > 0 || d.value > 0)
    ).length;

    const carouselPrev = () => {
      this.slider.slickPrev();
      const cs = this.state.currentSlide;
      let slideNumber = cs > 1 ? cs - 1 : data.length;

      trackXrayCarousel(
        "Xray Tooltip Insights Previous",
        "Insights",
        `${slideNumber + "/" + data.length}`,
        slideNumber
      );

      this.setState({
        currentSlide: slideNumber,
      });
    };

    const carouselNext = () => {
      this.slider.slickNext();
      const cs = this.state.currentSlide;
      let slideNumber = cs + 1 <= data.length ? cs + 1 : 1;

      trackXrayCarousel(
        "Xray Tooltip Insights Next",
        "Insights",
        `${slideNumber + "/" + data.length}`,
        slideNumber
      );

      this.setState({
        currentSlide: slideNumber,
      });
    };

    const renderAnalysisSlides = () => (
      <div className="slick-slider-container">
        {extra
          .filter((d) => d.key !== "insights" && d.value.total !== 0)
          .sort(
            (a, b) => (b.value.total || b.value) - (a.value.total || a.value)
          )
          .map((d, index) => (
            <div className="standard-tooltip__details" key={index}>
              <div className="standard-tooltip__item details-header">
                <span
                  className="standard-tooltip__icon"
                  style={{ background: d.color }}
                ></span>
                <span
                  className={clsx("standard-tooltip__key", "text-capitalize")}
                  style={{ color: d.color }}
                >
                  {d.key}
                </span>
                <span className="standard-tooltip__value">
                  {selectFormat("number", d.value.total || d.value)}
                </span>
              </div>

              <ul className="details-content">
                {Object.keys(d.value).filter((d) => d !== "total").length ? (
                  <li className="standard-tooltip__item">
                    <div
                      className={clsx("standard-tooltip__key", "compare-with")}
                    >
                      Breakdown:
                    </div>
                  </li>
                ) : null}
                {Object.keys(d.value)
                  .filter((d) => d !== "total")
                  .sort((a, b) => d.value[b].value - d.value[a].value)
                  .map((key, i) => {
                    return (
                      <li className="standard-tooltip__item" key={key + index}>
                        <div className="standard-tooltip__key">{key}</div>
                        <span className="standard-tooltip__value--small">
                          {getMetricForColumn(d.value[key])}
                        </span>
                      </li>
                    );
                  })}
                {data - 1 > index ? (
                  <div className="standard-tooltip__dilimiter2"></div>
                ) : null}
              </ul>
            </div>
          ))}
      </div>
    );

    let settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: true,
    };

    return (
      <div className="tooltip-slider pb-2">
        <div className="standard-tooltip__section-header mb-3 mt-3">
          Analysis
        </div>
        <Slider {...settings} ref={(c) => (this.slider = c)}>
          {renderAnalysisSlides()}
        </Slider>
        {data.length > 1 && (
          <XrayCarouselNav
            slide={this.state.currentSlide}
            data={data}
            next={(e) => carouselNext(e)}
            prev={(e) => carouselPrev(e)}
          />
        )}
      </div>
    );
  }
}
export default XrayAnalysisSlider;
